import Link from 'next/link';

export function DocLink({ doc }: any) {
  return (
    <div className="mx-1 my-2 rounded-md">
      <Link legacyBehavior href={doc}>
        <a className="flex items-center justify-center px-8 py-3 text-base font-medium bg-white border border-transparent rounded-md text-clerk-blue md:w-full hover:bg-gray-50 md:py-4 md:text-lg md:px-10 btn btn-outline">
          Explore the docs
        </a>
      </Link>
    </div>
  );
}
